


import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaShoppingBag, FaClipboardList, FaBox, FaCalendarAlt } from 'react-icons/fa';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  padding: 3rem;
  max-width: 600px;
  width: 100%;
  text-align: center;
`;

const SuccessIcon = styled(FaCheckCircle)`
  color: #10b981;
  font-size: 3rem;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: #555;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
`;

const OrderInfo = styled.p`
  font-weight: 500;
  color: #333;
  margin-bottom: 2rem;
`;

const OrderSummary = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  text-align: left;
`;

const SummaryTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1a1a1a;
`;

const OrderItem = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #eee;
  &:last-child {
    border-bottom: none;
  }
`;

const ItemImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
`;

const ItemDetails = styled.div`
  flex: 1;
`;

const ItemName = styled.p`
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: #333;
`;

const ItemQuantity = styled.p`
  color: #666;
  font-size: 0.9rem;
`;

const OrderTotal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
  font-weight: 600;
  color: #1a1a1a;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    transform: translateY(-2px);
  }
`;

const ContinueButton = styled(Button)`
  background-color: #3b82f6;
  color: white;
  border: none;
`;

const OrdersButton = styled(Button)`
  background-color: #10b981;
  color: white;
  border: none;
`;

const OrderConfirmation = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const order = state?.order;

  return (
    <Container>
      <Content>
        <SuccessIcon />
        <Title>Order Confirmed!</Title>
        <Message>Thank you for your purchase!</Message>
        <OrderInfo>
          Your order #{order?.orderId || 'N/A'} has been placed successfully.
        </OrderInfo>

        {order && (
          <OrderSummary>
            <SummaryTitle>Order Summary</SummaryTitle>
            {order.items.map((item, index) => (
              <OrderItem key={index}>
                <ItemImage src={item.image} alt={item.name} />
                <ItemDetails>
                  <ItemName>{item.name}</ItemName>
                  <ItemQuantity>
                    {item.quantity} × ${item.discountedPrice?.toFixed(2) || item.price.toFixed(2)}
                  </ItemQuantity>
                </ItemDetails>
              </OrderItem>
            ))}
            <OrderTotal>
              <span>Total:</span>
              <span>₹{order.total.toFixed(2)}</span>
            </OrderTotal>
          </OrderSummary>
        )}

        <ButtonGroup>
          <ContinueButton onClick={() => navigate('/products')}>
            <FaShoppingBag /> Continue Shopping
          </ContinueButton>
          <OrdersButton onClick={() => navigate('/orders')}>
            <FaClipboardList /> View Orders
          </OrdersButton>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

export default OrderConfirmation;





